module.exports = __webpack_public_path__ + "static/media/back.dbe46111.svg";